var exports = {
  "kL": "xe533113f--7b4546--container",
  "vK": "xe533113f--7b4546--banner",
  "Qq": "xe533113f--7b4546--text",
};

module.exports = exports;
